import {AutocompleteInput, ReferenceInput, ReferenceInputProps,} from "ra-ui-materialui";
import React from "react";

type ReferenceInputCategoryDocumentProps = Omit<
  ReferenceInputProps,
  "children" | "reference" | "sort"
>;

export const ReferenceInputCategoryDocument = (props: ReferenceInputCategoryDocumentProps) => {
  return (
    <ReferenceInput
      {...(props as ReferenceInputProps)}
      reference="autocomplete/category_document"
      sort={{ field: "name", order: "ASC" }}
      allowEmpty={true}
      label="Categoria documento"
    >
      <AutocompleteInput optionText="label" />
    </ReferenceInput>
  );
};
